export default __webpack_public_path__ + "static/media/arrow-rounded-left-6x9.fbab3a1a.svg";